import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgwWowService } from 'ngx-wow';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';


@Component({
  selector: 'app-inactive-user-reallocation',
  templateUrl: './inactive-user-reallocation.component.html',
  styleUrls: ['./inactive-user-reallocation.component.css']
})
export class InactiveUserReallocationComponent implements OnInit, AfterViewInit {

  lstData: any;
  columnsToHide: any = "ID, PID, DOC_TYPE_ID";
  hyperlinkCols: any = ['action_icon_Rule'];

  user_id: any;
  Userlist_active: any;
  selected_user_active: any;
  reassignedto: any;
  length: number = 0;
  URNarray: any;
  lstProcess: any;
  lstRole: any;
  inactive_Userlist: any;
  selectedProcess: any;
  selectedRole: any;
  selected_inactiveuser: any;
  req_status: any;

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private modalService: NgbModal,
    private memorystore: MemoryStorageService
  ) { }

  ngOnInit(): void {
    // this.getinactiveuser();
    //this.getProcess();
    //this.getactiveuser();
    this.getRole();

  }

  ngAfterViewInit() {

  }

  onGridCellClick(event: any) {

    var val = event.rowData.URN;

    if (event.rowData.action_checkbox_button == false) {
      this.URNarray.push(val)
    }
    else {

      const index = this.URNarray.indexOf(val);
      if (index > -1) { // only splice array when item is found
        this.URNarray.splice(index, 1); // 2nd parameter means remove one item only
      }
    }
  }

  selectallClick(event: any) {
    if (event.value == "true") {
      this.URNarray = [];
      this.lstData.forEach(e => {
        this.URNarray.push(e.URN)
      });
    }
    else {
      this.URNarray = [];
    }

  }


  submit_request() {

    let postSelectedURNList = [];
    if (this.URNarray.length == 0) {
      this.commonService.showMessageBox('Please select one URN', 'Warning');
      return;
    }

    if (this.reassignedto == null) {
      this.commonService.showMessageBox('Please select one User to re-assign', 'Warning');
      return;
    }
    this.URNarray.forEach(element => {

      let URNNo = element
      // var session_user = this.commonService.getUserInfoFromLocalStorage('userId');
      var session_user = this.memorystore.getItem('userId');
      this.lstData.forEach(e => {
        if (e.URN == URNNo) {
          let urn_exists = false;
          if (postSelectedURNList.length > 0) {
            let urn_data_exists = postSelectedURNList.filter((item) => item.doc_detail_id == e.ID);
            if (urn_data_exists != null && urn_data_exists.length > 0) {
              urn_exists = true;
            }
          }
          if (!urn_exists) {
            postSelectedURNList.push({
              process_id: e.PID,
              urn: e.URN,
              status: e.Status,
              doc_detail_id: e.ID,
              project_id: this.commonService.selectedProject,
              user_id: session_user,
              assigned_to: this.user_id,
              re_assigned_to: this.reassignedto
            });
          }
        }
      });

    });
    let param = {
      urnList: postSelectedURNList
    }
    if (postSelectedURNList.length > 0) {
      this.dataService.postData('update_reallocation', param).subscribe((res) => {
        if (res != null && res != undefined && (res.error_message == null || res.error_message == "")) {
          if (res.status) {
            this.commonService.showMessageBox('Selected URNs re-assigned successfully', 'Success');
          }
          else {
            this.commonService.showMessageBox('Unable perform URNs re-assignment', 'Erorr');
          }
          this.URNarray = [];
          this.getURNpendinglist();
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        });
    }
    else {
      this.commonService.showMessageBox('Please select one URN', 'Warning');
    }
  }

  onSelectProcess(process) {
    this.selectedProcess = process;
  }
  onSelectActiveUser(activeUser) {
    this.selected_user_active = activeUser;
    this.reassignedto = this.selected_user_active.id;
  }

  getProcess() {

    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('role_id', this.selectedRole.id);

    this.dataService.getData('GetProcessType_Reallocation', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          this.lstProcess = [];
          res.data.forEach((element) => {
            this.lstProcess.push({
              id: element.process_id,
              name: element.process_name
            });
          });
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  async onSelectRole(role) {
    this.selectedRole = role;
    this.URNarray = [];
    this.lstData = [];
    this.length = 0;
    this.getProcess();
    this.getactiveuser();
    this.getinactiveuser();
  }

  getRole() {
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);

    this.dataService.getData('GetReallocation-roles', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.data != null) {
          this.lstRole = [];
          res.data.forEach((element) => {
            this.lstRole.push({
              id: element.id,
              name: element.name,
            });
          });
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  Select_Inactiveuser(inactiveuser) {
    this.selected_inactiveuser = inactiveuser;
    this.user_id = this.selected_inactiveuser.id
  }

  search() {
    this.getURNpendinglist();
    this.getactiveuser();
  }

  onSelect_user_active(event: any) {


    this.reassignedto = this.selected_user_active.id
  }
  getURNpendinglist() {
    let validation_status = true;
    if (this.selectedRole == null || this.selectedRole == undefined) {
      this.commonService.showMessageBox('Please select role', 'Warning');
      validation_status = false;
    }
    else if (this.user_id == null || this.user_id == undefined) {
      this.commonService.showMessageBox('Please select inactive user.', 'Warning');
      validation_status = false;
    }

    // else if (this.selectedProcess == null || this.selectedProcess == undefined) {
    //   this.commonService.showMessageBox('Please select process', 'Warning');
    //   validation_status = false;
    // }

    if (validation_status) {
      let param = {
        project_id: this.commonService.selectedProject,
        user_id: this.user_id,
        process_id: 0, //not using  this.selectedProcess.id,
        role_id: this.selectedRole.id
      }
      this.dataService.getData('get_URNpendinglist', param).subscribe((res) => {
        if (res != null && res != undefined && (res.error_message == null || res.error_message == "")) {
          if (res.data != undefined && res.data != null) {
            this.length = res.data.Table.length;
            this.lstData = res.data.Table;
            this.lstData.forEach(e => {
              e["action_checkbox_button"] = false;
            });
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        });
    }
  }

  getinactiveuser() {

    let param = {
      project_id: this.commonService.selectedProject,
      Role_id: this.selectedRole.id,
      status: "INACTIVE"
    }
    //   this.inactive_Userlist = [];
    this.realloc_get_user(param);
  }

  getactiveuser() {
    this.Userlist_active = [];
    let param = {
      project_id: this.commonService.selectedProject,
      Role_id: this.selectedRole.id,
      status: "ACTIVE"
    }
    this.realloc_get_user(param);
  }

  realloc_get_user(param: any) {
    this.dataService.getData('realloc-get-user', param).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data.Table != null) {
          for (var i = 0; i < res.data.Table.length; i++) {
            if (param.status == "ACTIVE") {
              this.Userlist_active.push({
                id: res.data.Table[i].USER_ID,
                name: res.data.Table[i].USER_NAME,
              });
            }
            else {
              this.inactive_Userlist = [];
              res.data.Table.forEach((element) => {
                this.inactive_Userlist.push({
                  id: element.USER_ID,
                  name: element.USER_NAME,
                });

              });
            }
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

}


